/// <reference path="../../typings/browser.d.ts" />

namespace Application.Services {
    'use strict';

    // import HalConverter = Models.HalConverter;
    import DeviceParams = Application.Models.DeviceParams;

    export class FlexCollectorService {
        public static $name: string = "flexCollectorService";
        public static $inject: string[] = ['backendService', '$q', '$timeout', 'stompService'];

        private static maxRequestWait: number = 3000;
        private requestQueueLength: number = 16;

        private backendService: Services.BackendService;

        private backendBaseUrl: string = window.backendUrl;
        private flexCollectorBackendUrl: string = this.backendBaseUrl + 'flexcollector';
        private devicemapBackendUrl: string = this.flexCollectorBackendUrl + '/devicemap';

        private thumbnailUrl: string = window.backendUrl + 'thumbnail/device/';
        // private blockBackendUrl: string = this.flexCollectorBackendUrl + '/devicemap/block';
        // private streamPipeTrendingBackendUrl: string = this.flexCollectorBackendUrl + '/devicemap/streamPipe';
        private requestQueue: RequestSuburlMap = {};
        private requestQueueTimer: RequestTimeoutMap = {};

        constructor(backendService: Services.BackendService,
                    private qService: ng.IQService,
                    private $timeout: ng.ITimeoutService,
                    private stompService: StompService,
        ) {
            this.backendService = backendService;
        }

        public getAlarmsDeviceMap(): ng.IPromise<Object> {
            return this.backendService.get(this.devicemapBackendUrl, false)
                .then((devicemap: ng.IHttpPromiseCallbackArg<Object>) => {
                    return devicemap.data;
                });
        }

        public getDeviceParamsBySimplifiedHref(simplifiedHref: string): ng.IPromise<Models.DeviceParams> {
            return this.backendService.get(this.devicemapBackendUrl + '/' + simplifiedHref).then(
                (element: ng.IHttpPromiseCallbackArg<Models.IDeviceParams>) => {
                    return new DeviceParams(element.data);
                }
            );
        }

        public getDeviceParamsBySimplifiedHrefGrouped(subUrl: string, id: number): ng.IPromise<Models.DeviceParams> {
            if ( this.requestQueue[subUrl] === undefined ) {
                this.requestQueue[subUrl] = {};
            }

            let request: DeferredRequest = this.getOrCreateNewRequest(id, subUrl);
            return request.deferred.promise;
        }

        public subscribeDeviceParamsBySimplifiedHref(type: string, id: string,
                                                     callback: (deviceParams: Models.DeviceParams) => void): IStompSubscription {
            const iStompSubscription = this.stompService.dataSubscribe(type, id, callback);
            if (!iStompSubscription) {
                this.$timeout(() => {
                    console.log(`retrying subscription to ${type}/${id}`);
                    this.subscribeDeviceParamsBySimplifiedHref(type, id, callback);
                }, 400);
            }
            return iStompSubscription;
        }

        public setRequestQueueLength(length: number): void {
            this.requestQueueLength = length;
        }

        private getOrCreateNewRequest(id: number, subUrl: string): DeferredRequest {
            const idMap: IdDeferredRequestMap = this.requestQueue[subUrl];
            if (idMap[id] === undefined) {
                idMap[id] = [];
            }
            let requests: DeferredRequest[] = idMap[id];
            let flexCollectorRequest: DeferredRequest =
                new DeferredRequest(id, this.qService.defer(), subUrl);
            requests.push(flexCollectorRequest);

            let size: number = 0;
            Object.keys(idMap).forEach((key: string) => {
                size += idMap[key].length;
            });
            // console.log(`Request size for ${subUrl} is ${size}`);
            if (size >= this.requestQueueLength ) {
                this.$timeout.cancel(this.requestQueueTimer[subUrl]);
                this.requestQueueTimer[subUrl] = undefined;
                this.doMakeRequests(subUrl);
            } else {
                if (!this.requestQueueTimer[subUrl]) {
                    this.requestQueueTimer[subUrl] = this.$timeout(() => {
                        // if we go over max time without reaching the desired length, request anyway
                        this.doMakeRequests(subUrl);
                        this.requestQueueTimer[subUrl] = undefined;
                    }, FlexCollectorService.maxRequestWait);
                }
            }
            return flexCollectorRequest;
        }

        private doMakeRequests(subUrl: string): void {
            let tmpRequestQueue: IdDeferredRequestMap = this.requestQueue[subUrl];
            this.requestQueue[subUrl] = {};
            if (Object.keys(tmpRequestQueue).length > 0)
                this.getListRequestPromise(tmpRequestQueue, this.devicemapBackendUrl + "/" + subUrl + "/list" );
        }

        private getListRequestPromise(requestMap: IdDeferredRequestMap, url: string): void {
            let ids: number[] = Object.keys(requestMap).map((value: string) => {
                return parseInt(value, 10);
            });
            let requests: DeferredRequest[][] = ids.map((id: number) => {
                return requestMap[id];
            });
            this.backendService.post(url, {"ids": ids})
                .then((result: ng.IHttpPromiseCallbackArg<Models.IDeviceParams[]>) => {
                    let deviceParams: Models.IDeviceParams[] = result.data;
                    deviceParams.forEach((params: Models.IDeviceParams, index: number) => {
                        let requestsForIndex: DeferredRequest[] = requests[index];
                        if (requestsForIndex !== undefined) {
                            requestsForIndex.forEach((request: DeferredRequest) => {
                                request.deferred.resolve(new DeviceParams(params));
                            });
                        } else {
                            console.log(`Ids`, ids);
                            console.log(`Requests for index ${index} is not found!`, requests);
                            console.log(`Device params returned size ${deviceParams.length}`);

                        }
                    });
                });
        }
    }

    class RequestSuburlMap  {
        [key: string]: IdDeferredRequestMap;
    }

    class RequestTimeoutMap  {
        [key: string]: ng.IPromise<void>;
    }

}